module.exports = __webpack_public_path__ + "media/img/event/logo/applyboard-f89ee856a1cd448345e544a3bd87c741.jpg";